#import "./shiftInstanceInfo.gql"

query GetShiftInstanceByRange($scheduledStart: ISO8601DateTime!, $scheduledEnd: ISO8601DateTime!) {
  shiftInstances(scheduledStart: $scheduledStart, scheduledEnd: $scheduledEnd) @connection(key: "shiftInstances") {
    ...shiftInstanceInfo
  }
}
